export default {
  SET_REPOSITORY_RELATED_UUID: 'SET_REPOSITORY_RELATED_UUID',
};
